// Auth utility for BFF API
import {
  getCsrfToken,
  getCsrfTokenSync,
  setCsrfToken,
  clearCsrfToken,
  getHeadersWithCsrf,
  getHeadersWithCsrfSync,
} from './csrf';
const AUTH_TOKEN_KEY = 'accessToken';

export const getAuthToken = () => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};

export const setAuthToken = (token) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const clearAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
};

// Backward-compatible CSRF exports for existing imports from this module.
export { getCsrfToken, getCsrfTokenSync, setCsrfToken, clearCsrfToken };

export const getAuthHeaders = async () => {
  const token = getAuthToken();
  return getHeadersWithCsrf({ 'Authorization': `Bearer ${token}` });
};

export const getAuthHeadersSync = () => {
  const token = getAuthToken();
  return getHeadersWithCsrfSync({ 'Authorization': `Bearer ${token}` });
}; 